// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2x0lP","title":"Images90_title__2L9HG","images":"Images90_images__2G_FK"};